module.exports = __webpack_public_path__ + "static/media/1.0cab4e7a.jpg";